import React, { useMemo, memo } from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import WaveLayer from './components/WaveLayer';
import { createActions } from '../../store';
import WaveLayerControls from './components/WaveLayerControls';
import AddLayerButton from './components/AddLayerButton';

const styles = () => ({
    layersList: {
        width: '100%'
    }
});

const WaveLayersEditor = memo(({
    waveLayersLength,
    advanced,
    addWaveLayer,
    removeWaveLayer,
    duplicateWaveLayer,
    changeWaveLayerOrder,
    classes
}) => {
    const indexes = useMemo(() =>
        Array.from({ length: waveLayersLength }, (_, i) => i).reverse(),
        [waveLayersLength]
    );

    const layerActions = useMemo(() => ({
        remove: (index) => waveLayersLength > 1 ? () => removeWaveLayer(index) : null,
        moveUp: (index) => waveLayersLength > index + 1 ? () => changeWaveLayerOrder(index, index + 1) : null,
        moveDown: (index) => index !== 0 ? () => changeWaveLayerOrder(index, index - 1) : null,
        duplicate: (index) => waveLayersLength < 7 ? () => duplicateWaveLayer(index) : null
    }), [waveLayersLength, removeWaveLayer, changeWaveLayerOrder, duplicateWaveLayer]);

    return (
        <>
            <List
                dense
                disablePadding
                className={classes.layersList}
            >
                {advanced &&
                    <WaveLayerControls
                        waveLayersLength={waveLayersLength}
                        onAdd={addWaveLayer}
                        onRemove={removeWaveLayer}
                    />
                }

                {indexes.map((index) => (
                    <WaveLayer
                        key={index}
                        index={index}
                        title={`Wave Layer ${indexes.length - index}`}
                        advanced={advanced}
                        remove={layerActions.remove(index)}
                        moveUp={layerActions.moveUp(index)}
                        moveDown={layerActions.moveDown(index)}
                        duplicate={layerActions.duplicate(index)}
                    />
                ))}
            </List>

            {advanced && (
                <>
                    <br />
                    <AddLayerButton
                        disabled={waveLayersLength >= 7}
                        onClick={addWaveLayer}
                    />
                </>
            )}
        </>
    );
});

const mapStateToProps = (state) => ({
    waveLayersLength: state.createPreview.present.videoSettings.visualizer.waveCircles.length
});

const mapDispatchToProps = {
    addWaveLayer: createActions.addWaveLayer,
    removeWaveLayer: createActions.removeWaveLayer,
    duplicateWaveLayer: createActions.duplicateWaveLayer,
    changeWaveLayerOrder: createActions.changeWaveLayerOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(WaveLayersEditor, styles));